import { EMPTY_MASTER_STAFF_VSL_CODEANY_MODEL } from "presentation/model/StaffAndVesselCode/StaffAndVesselCodeMaintenanceModel"; 
import { useState } from "react"; 
import { createContainer } from "react-tracked"; 
const { 
    Provider: StaffAndVesselCodeMaintenanceProvider, 
    useTracked: useStaffAndVesselCodeMaintenanceTracked 
} = createContainer(() => useState(EMPTY_MASTER_STAFF_VSL_CODEANY_MODEL), {concurrentMode: true}); 
export { StaffAndVesselCodeMaintenanceProvider, useStaffAndVesselCodeMaintenanceTracked }; 
